"use client";

import React, { useState, useEffect } from "react";
import EsimRoamingSection from "./index";

type Country = {
  id: number | string;
  country_name: string;
  country_flag?: string;
  country_alpha_code?: string;
};

interface GeoResponse {
  countryKey: string;
  country: Country;
  detectedByIp: boolean;
  ipCountryCode: string | null;
}

interface EsimRoamingSectionWrapperProps {
  // Fallback country data for initial render (SSR/static)
  fallbackCountry: Country;
  fallbackCountryParam: string;
}

export default function EsimRoamingSectionWrapper({
  fallbackCountry,
  fallbackCountryParam,
}: EsimRoamingSectionWrapperProps) {
  const [country, setCountry] = useState<Country>(fallbackCountry);
  const [countryParam, setCountryParam] = useState(fallbackCountryParam);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const detectCountry = async () => {
      try {
        const response = await fetch("/api/geo");
        if (response.ok) {
          const data: GeoResponse = await response.json();
          setCountry(data.country);
          setCountryParam(data.countryKey);
        }
      } catch (error) {
        console.error("Failed to detect country:", error);
        // Keep using fallback country
      } finally {
        setLoading(false);
      }
    };

    detectCountry();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="inline-flex items-center gap-2">
          <div className="w-5 h-5 border-2 border-[#090EDB] border-t-transparent rounded-full animate-spin"></div>
          <span className="text-gray-600">Detecting your location...</span>
        </div>
      </div>
    );
  }

  return <EsimRoamingSection country={country} countryParam={countryParam} />;
}
